/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997RoutingModule
 * Purpose		: Routing module for CategorySalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CategorySalesfor1997ListComponent } from './CategorySalesfor1997List.component';
import { CategorySalesfor1997DetailsComponent } from './CategorySalesfor1997Details.component';

const CategorySalesfor1997Routes: Routes = [
	{ path: 'CategorySalesfor1997',  component: CategorySalesfor1997ListComponent },
	{ path: 'CategorySalesfor1997/Details/:id', component: CategorySalesfor1997DetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CategorySalesfor1997Routes)
  ],
  exports: [
    RouterModule
  ]
})

export class CategorySalesfor1997RoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CategorySalesfor1997/CategorySalesfor1997-routing.module.ts